import React from 'react';
import { useMatch } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import InvitePage from './InvitePage';
import UnauthenticatedInvitePage from './UnauthenticatedInvitePage';

export default function InviteManagement(): JsxNode {
  const res = useMatch('/invites/o/:platformUserId/:inviteSecret');
  const { isAuthenticated, isLoading } = useAuth0();
  const platformUserId = res?.params.platformUserId;
  const inviteSecret = res?.params.inviteSecret;

  if (isLoading || !platformUserId || !inviteSecret) {
    return null;
  }

  if (!isAuthenticated) {
    return <UnauthenticatedInvitePage inviteSecret={inviteSecret} platformUserId={platformUserId} />;
  }
  return <InvitePage inviteSecret={inviteSecret} platformUserId={platformUserId} />;
}
